import "@sass/base.sass"

import React from "react"
import Raven from "raven-js"
import { createRoot } from "react-dom/client"

import { AppRoot } from "@/components/app-root"

//@ts-ignore: ignore ie properties that doesn't actually exist in normal browsers
if (/msie\ [0-9]{1}/i.test(navigator.userAgent) || (!!window.MSInputMethodContext && !!document.documentMode)) {
	//using internet explorer
	alert("Internet Explorer is an unsupported browser, try using a modern browser if you experience any issues")
}

// Set up Sentry only in production, so console errors point to the right line
if (import.meta.env.PROD) {
	Raven.config("https://38189a0f7a7a49c48928273e23ac84cc@sentry.io/1253022", {
		shouldSendCallback: () => {
			return import.meta.env.PROD
		},
	}).install()
}

const container = document.getElementById("app")
const root = createRoot(container!)
root.render(<AppRoot />)
